import { getWardrobeList } from "../../redux/WardrobeSlice";
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import WardrobeIntro from './WardrobeIntro';
import WardrobeBox from "./WardrobeBox";
import SubMenuSuspense from '../../components/SubMenuSuspense';
import InnerHeaderSuspense from '../../layout/InnerHeaderSuspense';
import WardrobeAfter from "./WardrobeAfter";


function WardrobesPage() {
    // Fetching State
    const dispatch = useDispatch();
    const { page } = useSelector((state) => state.WardrobeList);
    const { status } = useSelector((state) => state.WardrobeList);
    const params = useParams();
  
    useEffect(() => {
      ////Passing page ID reference
      if (status !== "success") {
        dispatch(getWardrobeList({ url: params.id }));
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      }, [dispatch]);
  
      if (status === "loading") {
        return (
          <div className="PaddingTopHeding">
            {/* <InnerHeaderSuspense/> */}
          </div>
        );
      }
  
      if (status === "success") {
        // console.log(page)
    }
    return (
      <div className="WardrobeList PaddingTopHeding">
          {status === "success" ? (
            <>
            <WardrobeIntro/>
            <WardrobeBox GetWadrobeBoxEven={page} GetWadrobeBoxOdd={page} GetWadrobeModal={page} getimgSlider={page}/>
            <WardrobeAfter/>
            </>
          ) : null}
      </div>
    );
  }

  export default WardrobesPage;